export default __webpack_public_path__ + "static/media/sauces.19c2de33.png";